<template>
  <div>
    <!-- ---------------------------------------- header buttons section--------------------------  -->
    <div class="flex mt-5">
      <!-- segmment modal -->
      <SegmentModal
        :segmentPopup="segmentPopup"
        :callback="handleCloseSegment"
        :fetchCourseAgain="fetchCourse"
        :segmentOnly="courses"
      />
      <!-- left section  -->
      <section
        class="w-full overflow-y-scroll scrollbar-hide md:w-64 lg:w-144 xl:w-2/3"
        style="height: 82vh"
      >
        <div class="flex items-baseline justify-between">
          <h3 class="audience_header">List</h3>
          <button
            type="button"
            class="btn btn-primary ml-5"
            @click="handleCloseSegment"
          >
            <font-awesome-icon class="mr-3" size="lg" :icon="['fas', 'plus']" />
            New
          </button>
        </div>
        <div class="border-r-2 border-gray-500 pr-2">
          <CoursesList
            :courses="courses"
            :currentCourse="currentCourse"
            :callback="(e, index) => handleChangeCourese(e, index)"
            :fetchCourseAgain="fetchCourse"
            :loadMoreCourse="() => {}"
          />
        </div>
      </section>
      <!-- right section -->
      <section class="w-full ml-10 flex justify-between items-baseline">
        <EnrolledStudents
          :currentCourse="currentCourse"
          :courses="courses"
          :fetchCourseAgain="fetchCourse"
          :currentIndex="currentCourseIndex"
          :changeCurrentCourse="(e, index) => handleChangeCourese(e, index)"
          :courseCreatorId="userId"
        />
      </section>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import store from '@/store';
import EnrolledStudents from './EnrolledStudents.vue';
import CoursesList from './CoursesList.vue';
import SegmentModal from './SegmentModal.vue';
import utils from '@/services/utils';

export default {
  name: 'Overview',
  store,
  components: { EnrolledStudents, CoursesList, SegmentModal },
  data() {
    return {
      open: false,
      promoPopup: false,
      currentCourse: '',
      segmentPopup: false,
      userId: '',
      segmentOnly: [],
      currentCourseIndex: 0,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
    userInfo() {
      return this.$store.state.userDetails;
    },
    courses() {
      return this.$store.state?.courses?.coursesWithDetails;
    },
  },
  watch: {
    courses(newVal) {
      this.currentCourse = newVal[0]?._id;
    },
  },
  async mounted() {
    if (!this.userInfo) {
      await this.$store.dispatch('getMyDetails', {});
    }
    this.userId = this.userInfo?.userId;
    if (this.$route.query.userId) {
      this.userId = this.$route?.query?.userId;
    }
    await this.fetchCourse();
    if (this.$route.query.courseId) {
      this.currentCourse = this.$route.query.courseId;
    }
    this.getUserCourseInfo();
  },
  methods: {
    async fetchCourse() {
      try {
        store.commit('toggleLoading', true);
        await this.$store.dispatch('fetchCoursesListWithDetails', {
          userId: this.userId,
        });
        this.currentCourse = this.courses[0]?._id;
        store.commit('toggleLoading', false);
      } catch (error) {
        console.log('error course getting', error);
        store.commit('toggleLoading', false);
        utils.setStatusMsg(
          this,
          error?.response?.data?.message || 'something went wrong',
        );
      }
    },
    handleChangeCourese(courseId, index) {
      this.currentCourse = courseId;
      this.currentCourseIndex = index;
    },
    handleCloseSegment() {
      this.segmentPopup = !this.segmentPopup;
    },
    async getUserCourseInfo() {
      if (!this.userInfo) return;
      const usersRef = firebase.database().ref(`users/${this.userInfo._id}`);
      usersRef.on('value', this.snapshotData);
      console.log('is done task');
    },
    async snapshotData(snapshot) {
      const usersRef = firebase.database().ref(`users/${this.userInfo._id}`);
      const data = snapshot.val();
      console.log(data, 'users data');
      if (data?.isDone) {
        // fetching course

        await this.fetchCourse();
        // reset value
        usersRef.update({
          isDone: false,
        });
      }
    },
  },
};
</script>
